import { useEffect, useRef } from "react";

/**
 * Runs `onRestore` when the browser shows this page again from the back/forward cache, e.g. after
 * the user presses Back on Stripe or hosted sign-in. React state survives that restore, so a
 * loading state set before a same-tab redirect would otherwise spin forever.
 */
export function usePageRestore(onRestore: () => void) {
  const callback = useRef(onRestore);
  useEffect(() => {
    callback.current = onRestore;
  });

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) callback.current();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);
}
